import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import ProfileSettingsAccordionItem from '@Pages/ProfileSettings/Components/ProfileSettingsAccordionItem';
import { RadioButtonGroup } from '@els/els-react--radio-button';

import './SalutationSection.scss';

function SalutationSection({ label, value, onChange, onSave, onClose, title, options }) {
  const [selectedValue, setSelectedValue] = useState('');

  useEffect(() => {
    /** to handle no title case */
    if (value === '') {
      setSelectedValue(options?.find((opt) => opt.salutation === 'no title')?.salutation);
    } else {
      setSelectedValue(options?.find((opt) => opt.id === value)?.salutation);
    }
  }, [value, options]);

  function handleTitleChange(i) {
    const selectedOption = options.find((opt) => opt.salutation === i.target.value);
    onChange(selectedOption.id || '');
    setSelectedValue(selectedOption.salutation);
  }

  return (
    <ProfileSettingsAccordionItem onClose={onClose} label={label} value={value} onSave={onSave} formValid title={title} headingLevel="h3">
      <div className="salutation-section">
        <RadioButtonGroup
          data-e2e="salutation-radio-group"
          label="Choose Salutation"
          value={selectedValue}
          options={options?.map((opt) => opt.salutation)}
          a11y={{
            name: `${title}: ${selectedValue}`,
            description: `${title}: ${selectedValue}`,
          }}
          onChange={(i) => handleTitleChange(i)}
          shouldHideLabel
        />
      </div>
    </ProfileSettingsAccordionItem>
  );
}

SalutationSection.propTypes = {
  label: PropTypes.string.isRequired,
  title: PropTypes.string.isRequired,
  value: PropTypes.string,
  onChange: PropTypes.func.isRequired,
  onSave: PropTypes.func.isRequired,
  onClose: PropTypes.func.isRequired,
  options: PropTypes.arrayOf(PropTypes.shape({ id: PropTypes.string, salutation: PropTypes.string })),
};

export default SalutationSection;
